import { render } from "./NavbarCircleButton.vue?vue&type=template&id=0641e122&scoped=true"
import script from "./NavbarCircleButton.vue?vue&type=script&lang=js"
export * from "./NavbarCircleButton.vue?vue&type=script&lang=js"

import "./NavbarCircleButton.vue?vue&type=style&index=0&id=0641e122&scoped=true&lang=scss"

import exportComponent from "/home/tachyon/wardrobe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0641e122"]])

export default __exports__